import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

export function CardsSlideTemplate({ display, controls, slots }: SubTemplateProps) {
  const media = display.permissions.canViewContent && !display.access.isContentLocked
    ? display.media.primaryAttachment
    : undefined
  const mediaSrc = media?.src || media?.thumbSrc
  return (
    <>
      <div className={`md-subs-cards-row m-2 inline-flex h-[300px] w-[300px] flex-col overflow-hidden rounded-xl border border-[#ddd] bg-white text-[13px] shadow-[0_2px_8px_rgba(0,0,0,0.1)] transition hover:-translate-y-1 hover:shadow-[0_8px_24px_rgba(0,0,0,0.15)]${display.isChecked ? ' md-subs-cards-row--checked border-[#2196f3] bg-[#e3f2fd]' : ''}`}>
        <div className="md-subs-cards-head flex items-center gap-2 border-b border-[#eee] p-3">
          {controls.actions.check}
          <div className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap font-semibold [&_.md-sub-title-link]:text-[#333]">{controls.content.title}</div>
          {controls.actions.favorite}
        </div>
        {mediaSrc ? <img className="h-32 w-full flex-none object-cover" src={mediaSrc} alt={media.title || media.filename || display.title} /> : null}
        <div className="md-subs-cards-text min-h-0 flex-1 overflow-hidden p-3 leading-[1.35] text-[#555] [&_.md-sub-text]:whitespace-normal [&_.md-sub-text]:text-[#555]">
          {controls.content.text}
        </div>
        <div className="md-subs-cards-foot flex items-center justify-between border-t border-[#eee] p-3 text-xs text-[#2196f3]">
          {controls.content.time}
          {controls.actions.quickReply}
        </div>
      </div>
      <div className="md-subs-cards-children ml-4">{slots.allChildren}</div>
    </>
  )
}
